import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SignupService } from '@app-services/signup/signup.service';
import { UserService } from '@app-services/user/user.service';
import { SetnewPasswordDialogComponent } from '../setnew-password-dialog/setnew-password-dialog.component';
import { TestlistService } from '@app-services/test/testlist.service';
import { ConfirmEditPhoneNumberDialogComponent } from '../confirm-edit-phone-number-dialog/confirm-edit-phone-number-dialog.component';
import { EditPhoneNumberDialogComponent } from '../edit-phone-number-dialog/edit-phone-number-dialog.component';
import { LogindialogComponent } from '../logindialog/logindialog.component';
import { LoginService } from '@app-services/login/login.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { ClassService } from 'src/app/core/services/class.service';
import { environment } from 'src/environments/environment';
import { TenantConstant } from '@app-constants/tenant.constant';
import { AuthService } from '@app-services/auth-service/auth.service';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { navigateBetweenProjects, clearLocalStorage } from 'src/app/helpers/functions';
import { dashboardRoute } from '@app-constants/app.constants';

@Component({
  selector: 'app-verify-otp-dialog',
  templateUrl: './verify-otp-dialog.component.html',
  styleUrls: ['./verify-otp-dialog.component.css']
})
export class VerifyOtpDialogComponent implements AfterViewInit {
  tenant : any = TenantConstant.tenant;
  seconds: number = 60;
  counter: any;
  hideVerifyOtp = false;
  form: FormGroup;
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  timer: any;
  errorMessage: any;
  count = 0;
  validateOtpCounter = 0;
  sendTrackAPIOnSignInOrSignUp: boolean = environment?.sendTrackAPIOnSignInOrSignUp;

  constructor(
    private authService: AuthService,
    public signUpService: SignupService,
    public loginService: LoginService,
    private userService: UserService,
    private classService: ClassService,
    private testListService: TestlistService,
    private gaService: GAnalyticsService,
    private fb: FormBuilder,
    public router: Router,
    private cdRef: ChangeDetectorRef,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<VerifyOtpDialogComponent>) {
    this.form = fb.group({
      otp: [null],
    });
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.startCountdown(this.seconds);

    if (this.data.isNormalFlow) {
      this.gaService.sendEvent(
        'moved_to_verify_otp',
        'signup_otp',
        'moved_to_verify_otp',
        'reached',
      );
      this.gaService.sendEvent(
        'reached_verify_otp',
        'signup',
        'reached_verify_otp',
        'reached_verify_otp',
      );
    }
    //console.log('dialogData', this.userData);
    // this.form=this.fb.group({
    //   otp:[null],
    // });
    //this.dialogRef.disableClose = true;
  }

  onOtpChange(event: any) {
    // this.ngOtpInputRef.setValue(event);//yourvalue can be any string or number eg. 1234 or '1234'
    if (event.length === 4) {
      this.form.get('otp')?.setValue(event);
      document.getElementById('verifyOtp')?.focus();
    }
  }

  verifyOTP(): void {
    const data = this.data || {}
    if (data.isNormalFlow || data.isLoginWithOtp || data.isFormSubmit) {
      this.validateOtp()
    } else if (data.isEditPhoneNumber) {
      this.validateOtp2()
    } else if (data.isForgotPassword) {
      this.validateOtpForForgotPassword()
    }
  }

  validateOtp(): void {
    if (this.data.isNormalFlow) {
      this.gaService.sendEvent(
        'clicked_verify_otp',
        'signup_otp',
        'clicked_verify_otp',
        'clicked_verify_otp_btn',
      );
    }
    clearLocalStorage();
    let payload = {
      countryCode: this.data.countryCode, 
      phone: this.data.phone, 
      otp: this.form.value.otp, 
      register: false,
      "userActivityTrackingDataDto": !this.sendTrackAPIOnSignInOrSignUp 
      ? undefined 
      : {
        "data": {},
        "landingPage": ""
      },
    };
    this.signUpService.validateOtp(payload).subscribe((data) => {
      // this.toastr.success(data.message);
      if (data && data.accessToken) {
        if (this.data.isNormalFlow) {
          this.gaService.sendEvent(
            'correct_otp',
            'signup_otp',
            'correct_otp',
            'correct_otp_entered',
          );
          this.gaService.sendEvent(
            'User Onboarded',
            '',
            '',
            '',
            {'event': 'User Onboarded' ,
            'Phone Number': data.userDto.phone,
            'First Name': data.userDto.firstName,
            'Last Name': data.userDto.lastName,
            'City': null,
            'Email ID': data.userDto.email,
            'Mode': null,
            'User Source': null,
            'User id': data.userDto.userId,
            'No. of sessions': '',
            'Onboarding date': new Date().toJSON().slice(0,10).split('-').reverse().join('/')}
          )
          
          let body = [];
          body.push({ Attribute: 'FirstName', Value: data.userDto.firstName,  });
          body.push({ Attribute: 'LastName', Value: data.userDto.lastName});
          body.push({ Attribute: 'Phone', Value: data.userDto.phone });
          body.push({ Attribute: 'SearchBy', Value: 'Phone'})
          this.signUpService.leadSquaredJee(body);
        }
        console.log('JWT token', data);
        if (this.data.isLoginWithOtp){
          this.gaService.sendEvent(
            'User Login',
            '',
            '',
            '',
            {'event': 'User Login' ,
            'Phone Number': data.userDto.phone,
            'First Name': data.userDto.firstName,
            'Last Name': data.userDto.lastName,
            'City': null,
            'Email ID': data.userDto.email,
            'Mode': null,
            'User Source': null,
            'Whatsapp_consent': data.userDto?.whatsappConsent,
            }
          )
        }
        localStorage.setItem('token', data.accessToken)
        localStorage.setItem('tenant', data.tenantName);

        let gradeByName = data?.userDto?.grade?.name?.replace('st', '')?.replace('nd', '')?.replace('rd', '')?.replace('th', '');
        this.userService.setMobileAndName({
          phone: data.userDto.phone, isdCode: data.userDto.isdCode, firstName: data.userDto.firstName, lastName: data.userDto.lastName,
          whatsappConsent: data.userDto.whatsappConsent, userId: data.userDto.userId, profilePhoto: data.userDto.profilePhoto, grade: Number(gradeByName)
        });
        this.userService.setUserTypes(data.userDto.userType);
        this.userService.updateRequestedUserData(data.userDto);
        this.authService.updateAuthStatus(true);
        this.dialogRef.close(data)
        localStorage.setItem('studentid', this.data.phone)
        let _headers = {
          'accesstoken': data.accessToken,
          'studentid': localStorage.getItem('studentid'),
          // 'methodtype': 'RULES'
        };
        if (this.data?.isLoginWithOtp) {
          this.saveAccessToken(_headers, this.data.isLoginWithOtp);
        }
      } else {
        this.errorMessage = 'The OTP is incorrect, please enter again';
        if (this.data.isNormalFlow) {
          this.gaService.sendEvent(
            'incorrect_otp',
            'signup_otp',
            'incorrect_otp',
            'incorrect_otp_entered',
          );
        }
      }
    },
      (error) => {                                     // on error
        // this.toastr.warning(error.error.message)
        this.errorMessage = error.error.message
        if (this.errorMessage.toLowerCase().indexOf("incorrect") > -1) {
          this.gaService.sendEvent(
            'incorrect_otp',
            'signup_otp',
            'incorrect_otp',
            'incorrect_otp_entered',
          );
        }
        // alert(error.error.message);
        // this.openOTPVerificationPopup();
      });
  }

  validateOtp2(): void {
    this.userService.validateOtpForEditPhone(this.data.countryCode, this.data.phone, this.form.value.otp).subscribe((data: any) => {
      if (data) {
        // this.test1()
        // this.dialogRef.close(`${this.data.phone}`);
        this.editPhoneNumber(this.data.userObject)
      } else if (data === false) {
        this.errorMessage = 'The OTP is incorrect, please enter again'
      }
    },
      (error: any) => {                                     // on error
        console.log(error);
      });
  }

  validateOtpForForgotPassword(): void {
    clearLocalStorage();
    this.signUpService.validateOtpForForgotPassword(this.data.countryCode, this.data.phone, this.form.value.otp).subscribe((data: any) => {
      if (data) {
        this.openSetNewPasswordDialog(data.accessToken, data?.userDto?.userId)
      }
    },
      (error: any) => {                                     // on error
        console.log(error);
        this.errorMessage = 'The OTP is incorrect, please enter again'
      });
  }

  saveAccessToken(_headers: any, navigateToDashboard: any): any {
    if (this.data?.actionData?.redirection) {
      //this.router.navigate([this.data?.actionData?.redirection]);
          alert(this.data?.actionData?.redirection);

      navigateBetweenProjects(this.router, this.data?.actionData?.redirection);
    } else {
      let route = dashboardRoute;
      let userType = this.userService.getUserType()
      if(userType == 2){
        route += '/liveclass';
      } else {
        if(environment?.portal == 'teacher'){
          this.loginService.logoutEvent.emit({showPopup: true, message: 'Oops!', message2: `Seems like you are not a registerd teacher.`});
          return;
        }
      }
      navigateBetweenProjects(this.router, route);
    }

  }

  editPhoneNumber(value: any): any {
    const obj = value;
    this.openPhoneNumberUpdatedConfirmDialog(this.data.phone);
  }

  openPhoneNumberUpdatedConfirmDialog(val: any) {
    this.dialogRef.close()
    const config: MatDialogConfig = {
      width: '487px',
      height: '258px',
      data: {
        message: 'Phone number updated',
        message2: `Your phone number has been updated to ${val}`,
        actionData: this.data?.actionData
      }
    };
    const dialogRef = this.dialog.open(ConfirmEditPhoneNumberDialogComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        console.log('value', value)
        this.dialogRef.close(`${this.data.phone}`);
        this.dialog.closeAll()
        
      }
    });
  }

  editMobileNumber2() {
    this.dialogRef.close();
    const config: MatDialogConfig = {
      width: '487px',
      height: '295px',
      data: {
        message: 'Edit Phone Number',
        isEditVerifyOtp: true,
        actionData: this.data?.actionData,
        HideSCMsg: true
      }
    };
    const dialogRef = this.dialog.open(LogindialogComponent, config);
  }

  startCountdown(seconds: any) {
    this.counter = seconds;
    const interval = setInterval(() => {
      this.counter--;
      if (this.counter < 10) {
        if (this.counter == 0) {
          this.hideVerifyOtp = true;
          clearInterval(interval);
          document.getElementById('resendOtp')?.focus()
        }
        this.counter = '0' + this.counter
      }
    }, 1000); //for accurate reading, adjust this value to 980-996
  }

  resendOTP() {
    if (this.count >= 25) {
      alert('You have reached maximum of 5 attempts') //5 or 25?
    } else {
      this.signUpService.generateOtp(this.data, this.data.countryCode).subscribe((data: any) => {
        if (data) {
          console.log(data);
          this.count = this.count + 1;
          this.startCountdown(this.seconds);
          this.hideVerifyOtp = false;
        }
        // document.getElementById('otpboxes')?.focus();
      });
    }
  }

  openSetNewPasswordDialog(accessToken: any, userId: any) {
    this.dialogRef.close();
    const config: MatDialogConfig = {
      width: '439px',
      height: '340px',
      panelClass: 'phone-number-verify',
      data: {
        message: 'Phone Number Verified',
        message2: `Please set a new password for your account`,
        countryCode: this.data.countryCode,
        phone: this.data.phone,
        userId,
        actionData: this.data?.actionData
      }
    };
    localStorage.setItem('token', accessToken)
    localStorage.setItem('studentid', this.data.phone)
    let _headers = {
      'accesstoken': accessToken,
      'studentid': `${this.data.phone}`,
    };
    this.dialogRef.close();
    const dialogRef = this.dialog.open(SetnewPasswordDialogComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        console.log('value', value)
      }
    });
  }

  closeDialogue() {
    this.dialogRef.close();
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
    // this.startCountdown(this.seconds);
  }

}
